import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, inject, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { NotificationsService } from '../../../../shared/components/notifications/service/notifications.service';
import { ResendEmailVerificationService } from './service/resend-email-verification.service';
import { LoaderSubitoService } from '../../../../shared/components/loader-subito/service/loader-subito.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'resend-email-verification',
  imports: [CommonModule],
  templateUrl: './resend-email-verification.component.html',
  styleUrl: './resend-email-verification.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResendEmailVerificationComponent implements OnChanges {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();
  @Input() email = '';
  isLoading = signal(false);


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      if (!this.open) {
        this.email = '';
      }
    }
  }

  notificationService = inject(NotificationsService)
  resendEmailVerificationService = inject(ResendEmailVerificationService)
  spinnerSubitoService = inject(LoaderSubitoService)

  close() {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent) {
    // Cierra solo si se hace clic en el backdrop (no dentro del modal)
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.close();
  }

  onSendEmail() {
    this.isLoading.set(true);
    this.spinnerSubitoService.showLoader();
    this.resendEmailVerificationService.sendEmail(this.email).pipe(
      finalize(() => this.spinnerSubitoService.hideLoader())
    ).subscribe({
      next: () => {
        this.notificationService.addNotification({
          message: 'Correo de verificación reenviado. Por favor, verifica tu correo electrónico.',
          type: 'success',
        });
        this.close();
      },
      error: () => {

      }
    })
  }
}
